import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Rating, Stack, Typography } from '@mui/material';
import { ModalOutProps } from 'new/routes/ModalDefault';
import { ModalComponent, ModalConfig } from 'new/routes/RouterManager';
import styles from './ModalRateDataProduct.module.scss';
import { Nexset } from 'new/entities/Nexset';
import { useModals } from 'new/hooks/useModals';
import { addDomainItemRating } from 'js/actions';

interface ModalRateDataProductProps {
  item: Nexset;
  domainId: number;
}

export const ModalRateDataProduct: ModalComponent = (
  props: ModalRateDataProductProps & ModalOutProps,
) => {
  const { item, domainId, setModalActions } = props;
  const dispatch = useDispatch();
  const { closeModal } = useModals();
  const [currentRating, setCurrentRating] = useState(null);
  const [submit, setSubmit] = useState(false);

  useEffect(() => {
    setModalActions({
      ok: {
        text: 'Save',
        onClick: () => setSubmit(true),
      },
    });
  }, []);

  useEffect(() => {
    if (submit && currentRating !== null) {
      dispatch(addDomainItemRating(item?.id, domainId, currentRating));
      closeModal(ModalRateDataProduct.modalConfig.name);
      setSubmit(false);
    }
  }, [submit, currentRating]);

  return (
    <Stack className={styles.modalRateContainer}>
      <Stack>
        <Typography variant="h3">{item?.name}</Typography>
      </Stack>
      <Stack direction="row" gap="80px">
        <div className={styles.rating}>
          <Typography className={styles.label}>MY RATING</Typography>
          <Rating
            defaultValue={item?.rating}
            value={currentRating}
            onChange={(event, newRating) => {
              setCurrentRating(newRating);
            }}
          />
        </div>
        <div className={styles.rating}>
          <Typography className={styles.label}>OVERALL RATING</Typography>
          <Rating value={item?.rating} readOnly />
        </div>
      </Stack>
      <Stack>
        <Typography>
          Rate the accuracy, completeness, consistency, interoperability, and documentation of this
          data product.
        </Typography>
      </Stack>
    </Stack>
  );
};

ModalRateDataProduct.modalConfig = {
  name: 'ModalRateDataProduct',
  title: 'Rate Data Product',
} as ModalConfig;
